import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {useCachedTable} from 'src/hooks/common-data-service/cached-table';
import {getProfileChangeHistory} from 'src/openapi/admin/apis/ProfileChangeHistoryApi';
import {useAppDispatch} from 'src/store/hooks';

import {profileHistoryStateSelector} from '../slices/profile-history-state.slice';
import {
    profileHistoryActions,
    profileHistoryDataSelector,
    profileHistoryResultSelector,
} from '../slices/profile-history.slice';

import type {CacheKeys} from 'src/hooks/common-data-service/cached-table';
import type {ProfileChangeHistory} from 'src/openapi/admin/models/ProfileChangeHistory';

type ProfileHistoryCacheKeys = CacheKeys<{profileId: number}, undefined, undefined>;

export const useGetProfileHistory = () => {
    const apiDispatch = useAppDispatch();
    const dispatch = useDispatch();

    const getAction = useCallback((cacheKeys: ProfileHistoryCacheKeys) => apiDispatch(
        getProfileChangeHistory({profileId: cacheKeys.searchCriteria.profileId || -1}),
    ), [apiDispatch]);

    const setLoadedData = useCallback((
        response: ProfileChangeHistory,
        cacheKeys: ProfileHistoryCacheKeys,
    ) => {
        const {pagination: {currentPage, pageSize}} = cacheKeys;

        dispatch(profileHistoryActions.onSuccess(({
            cacheKeys,
            totalCount: response.totalCount,
            data: response.eventList.slice((currentPage - 1) * pageSize, currentPage * pageSize),
        })));
    }, [dispatch]);

    return useCachedTable({
        dataSelector: profileHistoryDataSelector,
        stateSelector: profileHistoryStateSelector,
        resultSelector: profileHistoryResultSelector,
        actions: profileHistoryActions,
        getAction,
        onSuccessLoad: setLoadedData,
    });
};
